import { createAsyncThunk } from '@reduxjs/toolkit'
//import axios from 'axios';
// import { firestore } from '../../Firebase'
import {
//   addDoc,
//   collection,
//   doc,
//   getDoc,
//   getDocs,
//   increment,
//   query,
//   serverTimestamp,
  Timestamp,
//   updateDoc,
//   where,
//   writeBatch,
 } from 'firebase/firestore'
import { ContractFormType } from '../../views/Contract/contracts'
import { toast } from 'react-toastify'
import { NavigateFunction } from 'react-router-dom'
import { PendingClientType } from '../slices/clientsSlice'
import { getAuth } from 'firebase/auth'
import { sendInviteDispatch } from '../../api/awsApis'

const SERVER_URL = "https://us-central1-elisyanwealth.cloudfunctions.net/";
const BASE_URL =
  "http://127.0.0.1:5001/elisyanwealth/us-central1/";

// Access-codes + contracts domain is wired to the v2 `_v2` endpoints
// (functions/v2Endpoints.js). While pre-deploy testing against the functions
// emulator, ACCESSCODE_V2_BASE is BASE_URL; set ACCESSCODE_V2_DEPLOYED = true
// once the `_v2` functions are live to point back at production. The whole
// domain must move together: v2 contract ids are `${businessId}_${reference}`,
// not the legacy auto-ids, so mixing legacy contract reads with v2 code
// writes (or vice-versa) would not resolve.
const ACCESSCODE_V2_DEPLOYED = true;
const ACCESSCODE_V2_URL = ACCESSCODE_V2_DEPLOYED ? SERVER_URL : BASE_URL;
/*
interface addContractArgs {
    business_client: string | undefined;
    contract_ref: string | undefined;
    useLimit: number | undefined;
    expire_at: string | undefined;
  }
interface AddContractResponse {
    id: string;
    business_client: string | undefined;
    contract_ref: string | undefined;
    useLimit: number | undefined;
    expire_at: string | undefined;
}
*/

// Define your types if needed for the form values
export interface ContractType {
  business_client: string | undefined
  contract_ref: string | undefined
  useLimit: number
  expire_at: Date | string | undefined
  id?: string | undefined
  licence_count: number
}

interface getBusinessesArgs {
  type: string | undefined
}
export interface BusinessesType {
  id: string
  type: string
  name: string
}

// Define the structure for an error response
interface ErrorResponse {
  message: string
  error: string
}

// export const getBusinesses = createAsyncThunk<
//   BusinessesType[] | undefined,
//   getBusinessesArgs
// >('accessCode_slice/getBusinesses', async ({ type }, thunkAPI) => {
//   try {
//     const businessesRef = collection(firestore, 'businesses')
//     let querySnapshot

//     if (type && type.length > 3) {
//       const businessesQuery = query(businessesRef, where('type', '==', type))
//       querySnapshot = await getDocs(businessesQuery)
//     } else {
//       querySnapshot = await getDocs(businessesRef)
//     }

//     const businesses: BusinessesType[] = querySnapshot.docs.map((doc) => ({
//       id: doc.id,
//       type: doc.data().type ?? 'unknown', // Ensure the "type" field is always available
//       name: doc.data().name ?? 'unknown', // Ensure the "name" field is always available
//     }))

//     return businesses
//   } catch (e) {
//     // console.log("-------------- Error register User Device Token" + e);
//     return thunkAPI.rejectWithValue({
//       message: 'Error retrieving businesses',
//       error: e,
//     } as ErrorResponse)
//   }
// })
export const getBusinesses = createAsyncThunk(
  'accessCode_slice/getBusinesses',
  async ({ type }: { type?: string }, thunkAPI) => {
    try {
      const token = await getAuth().currentUser?.getIdToken()
      const res = await fetch(`${ACCESSCODE_V2_URL}getBusinessesByType_v2`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ type }),
      })
      const { data } = await res.json()
      if (!res.ok) throw new Error('Failed')
      return data
    } catch (e) {
      return thunkAPI.rejectWithValue({ message: 'Error retrieving businesses' })
    }
  }
)

export const getContractsByBusinesses = createAsyncThunk<
  ContractType[] | undefined,
  { business_names: string[] }
>('accessCode_slice/getContracts', async ({ business_names }, thunkAPI) => {
  try {
      // Get the current user's token directly from Firebase Auth
      const auth = getAuth();
      const user = auth.currentUser;
      
      if (!user) {
        return thunkAPI.rejectWithValue('User not authenticated');
      }
      
      // Get fresh token (Firebase automatically refreshes if needed)
      const token = await user.getIdToken();
    const response = await fetch(
      `${ACCESSCODE_V2_URL}getContractsByBusinesses_v2`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          business_names: business_names,
        }),
      },
    )

    const result = await response.json()

    if (!response.ok) {
      throw new Error(result.message || 'Failed to fetch contracts')
    }

    // Map the response to the expected ContractType
    const contracts: ContractType[] = result.data.map((contract: any) => ({
      id: contract.id,
      business_client: contract.business_client,
      contract_ref: contract.contract_ref,
      useLimit: contract.useLimit,
      expire_at: toDateOnly(contract.expire_at),
      licence_count: contract.licence_count,
    }))
    //console.log("Fetched contracts accessCode actions:", contracts);
    return contracts
  } catch (e) {
    console.error('-------------- Error getContracts:', e)
    return thunkAPI.rejectWithValue({
      message: 'Error retrieving contracts',
      error: e,
    } as ErrorResponse)
  }
})

export const getContracts = createAsyncThunk<
  ContractType[] | undefined,
  { business_client: string }
>('accessCode_slice/getContracts', async ({ business_client }, thunkAPI) => {
  try {
    const token = await getAuth().currentUser?.getIdToken()
    const res = await fetch(
      `${ACCESSCODE_V2_URL}getContracts_v2`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ business_client }),
      },
    )

    const { data, message } = await res.json()
    if (!res.ok) throw new Error(message || 'Failed to fetch contracts')

    const contracts: ContractType[] = data.map((c: any) => ({
      id: c.id,
      business_client: c.business_client,
      contract_ref: c.contract_ref,
      useLimit: c.useLimit,
      expire_at: toDateOnly(c.expire_at),
      licence_count: c.licence_count,
    }))

    return contracts
  } catch (e) {
    console.log('-------------- Error getContracts', e)
    return thunkAPI.rejectWithValue({
      message: 'Error retrieving contracts',
      error: e,
    } as ErrorResponse)
  }
})

export const addContract = createAsyncThunk<
  ContractType | undefined,
  ContractFormType
>(
  'accessCode_slice/addContract',
  async ({ business_client, contract_ref, useLimit = 1, expire_at }, thunkAPI) => {
    try {
      const token = await getAuth().currentUser?.getIdToken()
      const res = await fetch(
        `${ACCESSCODE_V2_URL}addContract_v2`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ business_client, contract_ref, useLimit, expire_at }),
        },
      )

      const { data, message } = await res.json()
      if (!res.ok) throw new Error(message || 'Failed to add contract')

      toast.success('Contract added successfully!')

      return {
        id: data.id,
        contract_ref,
        business_client,
        useLimit,
        expire_at,
        licence_count: 0,
      }
    } catch (e) {
      console.log('-------------- Error adding new contract', e)
      return thunkAPI.rejectWithValue({
        message: 'Error while adding a new contract',
        error: e,
      } as ErrorResponse)
    }
  },
)


// export const getContracts = createAsyncThunk<
//   ContractType[] | undefined,
//   { business_client: string }
// >('accessCode_slice/getContracts', async ({ business_client }, thunkAPI) => {
//   try {
//     const contractsRef = collection(firestore, 'contracts')
//     let querySnapshot

//     if (business_client && business_client.length > 3) {
//       const businessDocRef = doc(firestore, `businesses/${business_client}`)
//       const contractsQuery = query(
//         contractsRef,
//         where('owner', '==', businessDocRef),
//       )
//       querySnapshot = await getDocs(contractsQuery)
//     } else {
//       querySnapshot = await getDocs(contractsRef)
//     }

//     const contracts: ContractType[] = querySnapshot.docs.map((doc) => ({
//       business_client: doc.data().owner.id,
//       contract_ref: doc.data().reference,
//       useLimit: doc.data().use_limit,
//       expire_at: doc.data().expire_at,
//       licence_count: doc.data().licence_count,
//       id: doc.id,
//     }))

//     return contracts
//   } catch (e) {
//     console.log('-------------- Error getContracts' + e)
//     return thunkAPI.rejectWithValue({
//       message: 'Error retrieving contracts',
//       error: e,
//     } as ErrorResponse)
//   }
// })
// export const addContract = createAsyncThunk<
//   ContractType | undefined,
//   ContractFormType
// >(
//   'accessCode_slice/addContract',
//   async (
//     { business_client, contract_ref, useLimit = 1, expire_at },
//     thunkAPI,
//   ) => {
//     try {
//       // const contractCollection = collection(firestore, "contracts");
//       const ownerRef = doc(firestore, `businesses/${business_client}`)

//       // Reference to the contracts collection
//       const contractsRef = collection(firestore, 'contracts')

//       // Create the contract document with the specified fields
//       const newContract = {
//         owner: ownerRef, // Firestore document reference for owner
//         reference: contract_ref, // string field for reference
//         use_limit: useLimit, // number field for use limit
//         expire_at: expire_at, // Firestore Timestamp from Date object
//         licence_count: 0,
//         created_at: (serverTimestamp() as unknown) as Timestamp, // Firestore server timestamp
//       }

//       // Add the contract document to the collection
//       const docRef = await addDoc(contractsRef, newContract)
//       toast.success('Contract added successfully!')
//       // Return the document ID of the newly created contract
//       return {
//         id: docRef.id,
//         contract_ref,
//         business_client,
//         useLimit,
//         expire_at,
//         licence_count: 0,
//       }
//     } catch (e) {
//       console.log('-------------- Error adding new contract' + e)
//       return thunkAPI.rejectWithValue({
//         message: 'Error while adding a new contract',
//         error: e,
//       } as ErrorResponse)
//     }
//   },
// )

interface FormRole {
  label: string
  value: string
}
interface AccessCodeArgs {
  role_type: string
  roles?: FormRole[]
  codeType: string
  contract_ref?: string
  business_client: string
  email?: string[]
  expire_at?: string
  number_of_codes_to_generate: number
  navigate?: NavigateFunction
}

export interface AccessCodeType {
  id: string
  role_type: string
  roles?: string[]
  codeType: string
  contract_ref?: string
  business_client: string
  for_business_client?: string
  prefix?: string
  email?: string[]
  expire_at: string
  isActive?: boolean
  useLimit?: number
  useCount?: number
  validated: boolean
  shared: boolean
  created_at: Timestamp | Date | string
  updated_at: Timestamp | Date | string
  free_duration?: number // Optional field for free duration
}

/** v2 sends dates as full ISO timestamps ("2025-09-15T00:00:00.000Z"); v1
 * stored plain "YYYY-MM-DD", which is what the access-code and contract
 * screens render as-is and string-compare against today's date. */
export const toDateOnly = (value: unknown): string => (typeof value === 'string' ? value.slice(0, 10) : '')

/** Same normalisation for the codes a create endpoint echoes back, which go
 * straight into the slice next to the fetched ones. */
const withDateOnlyExpiry = (codes: AccessCodeType[] | undefined): AccessCodeType[] =>
  (codes || []).map((code) => ({ ...code, expire_at: toDateOnly(code.expire_at) }))

/** Maps one raw doc from `getAccessCodesByBusinesses_v2` into `AccessCodeType`.
 * v2 serializes refs to a plain id string; legacy sent a Firestore ref
 * shaped like `{_path:{segments}}` — tolerate both. */
// `raw` is untyped server JSON — same as the other response mappers in this file.
export function mapRawAccessCode(raw: any): AccessCodeType {
  return {
    id: raw.id,
    role_type: raw.role_type,
    roles: raw.roles || [],
    codeType: raw.codeType,
    contract_ref:
      (typeof raw.contract_ref === 'string'
        ? raw.contract_ref
        : raw.contract_ref?._path?.segments?.[1]) || undefined,
    business_client:
      (typeof raw.business_client === 'string'
        ? raw.business_client
        : raw.business_client?._path?.segments?.[1]) || undefined,
    for_business_client: raw.for_business_client || undefined,
    prefix: raw.prefix || undefined,
    email: raw.email || [],
    expire_at: toDateOnly(raw.expire_at),
    isActive: raw.isActive,
    useLimit: raw.useLimit ?? 0,
    useCount: raw.useCount ?? 0,
    validated: raw.validated,
    shared: raw.shared,
    created_at: raw.created_at,
    updated_at: raw.updated_at,
    free_duration: raw.free_duration || undefined,
  } as AccessCodeType
}

/** True when a code can still be handed to a new client: for the right
 * business, still active, not fully consumed, not expired. Used by the Send
 * Invitation form. */
export function isAccessCodeSendable(code: AccessCodeType, businessId?: string): boolean {
  if (businessId && code.business_client !== businessId) return false
  if (code.validated) return false
  if (code.isActive === false) return false
  const limit = code.useLimit ?? 0
  const used = code.useCount ?? 0
  if (limit > 0 && used >= limit) return false
  if (code.expire_at) {
    const exp = new Date(code.expire_at)
    if (!Number.isNaN(exp.getTime()) && exp.getTime() <= Date.now()) return false
  }
  return true
}

/** Fetches the access codes a business owns (looked up by name), mapped to
 * `AccessCodeType`. Plain async fn — the Send Invitation form uses this
 * instead of the `getAccessCodes` thunk so it doesn't overwrite the shared
 * `accessCodes` slice state that the Access Codes screen relies on. */
export async function fetchAccessCodesForBusiness(businessName: string): Promise<AccessCodeType[]> {
  const user = getAuth().currentUser
  if (!user) throw new Error('Not authenticated')
  const token = await user.getIdToken()
  const res = await fetch(`${ACCESSCODE_V2_URL}getAccessCodesByBusinesses_v2`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ business_names: [businessName] }),
  })
  const json = await res.json()
  if (!res.ok) throw new Error(json?.message || 'Failed to load access codes')
  const list = Array.isArray(json?.data) ? json.data : []
  return list.map(mapRawAccessCode)
}

// export const addAccessCode = createAsyncThunk<
//   AccessCodeType[] | undefined, // Correctly defining return type as AccessCodeType[]
//   AccessCodeArgs
// >(
//   'accessCode_slice/addAccessCode',
//   async (
//     {
//       navigate,
//       role_type,
//       roles,
//       codeType,
//       contract_ref,
//       business_client,
//       email,
//       expire_at,
//       number_of_codes_to_generate,
//     },
//     thunkAPI,
//   ) => {
//     try {
//       const accessCodeCollection = collection(firestore, 'access_codes')
//       const contractRef = doc(firestore, `contracts/${contract_ref}`)
//       const contractSnap = await getDoc(contractRef)
//       let contract_expire_at: string = ''
//       if (contractSnap.exists()) {
//         const contractData = contractSnap.data()
//         contract_expire_at = contractData.expire_at || ''
//       } else {
//         // console.log("No such document!");
//       }
//       const business_clientRef = doc(firestore, `businesses/${business_client}`)
//       const newAccessCodes = [] // Array to store the AccessCodeType objects
//       const newAccessCodesids: string[] = []
//       if (codeType === 'licence-code') {
//         for (let i = 0; i < number_of_codes_to_generate; i++) {
//           const newAccessCodeRef = doc(accessCodeCollection) // Generate a new document reference
//           const newCode = {
//             role_type: role_type,
//             roles: roles?.map((item) => item.value),
//             codeType,
//             contract_ref: contractRef, // Assuming contract_ref is a string path
//             business_client: business_clientRef,
//             email: email ?? [], // Default to an empty array if undefined
//             expire_at: expire_at ?? contract_expire_at, // Default to an empty string if undefined
//             created_at: (serverTimestamp() as unknown) as Timestamp,
//             updated_at: (serverTimestamp() as unknown) as Timestamp,
//             validated: false,
//             shared: false,
//           }

//           newAccessCodes.push(newCode) // Add the new code to the array
//           newAccessCodesids.push(newAccessCodeRef.id)
//         }
//       }

//       // Initialize the batch
//       const batch = writeBatch(firestore)

//       // Add each access code to the batch
//       newAccessCodes.forEach((accessCode, index) => {
//         const newAccessCodeRef = doc(
//           accessCodeCollection,
//           newAccessCodesids[index],
//         ) // Use the pre-generated ID
//         batch.set(newAccessCodeRef, accessCode) // Add the document to the batch
//       })

//       // Commit the batch write
//       try {
//         await batch.commit()
//         const createdCodes: AccessCodeType[] = newAccessCodes.map(
//           (code, index) => {
//             return {
//               ...code,
//               business_client: code.business_client.path.split('/')[1],
//               contract_ref: code.contract_ref.path.split('/')[1],
//               id: newAccessCodesids[index],
//               created_at: new Date().toISOString().slice(0, 10),
//               updated_at: new Date().toISOString().slice(0, 10),
//             }
//           },
//         )
//         // Update the contract to increase licence_count
//         await updateDoc(contractRef, {
//           licence_count: increment(number_of_codes_to_generate), // Increase licence_count by the number of codes generated
//         })
//         toast.success('Access codes Created  successfully!')
//         if (navigate) {
//           navigate(`../accessCode/${newAccessCodesids[0]}`)
//         }

//         return createdCodes
//       } catch (error) {
//         console.error('Batch write failed:', error)
//         return thunkAPI.rejectWithValue({
//           message: 'Batch write failed',
//           error,
//         })
//       }
//     } catch (e) {
//       // console.log("Error registering Access Codes:", e);
//       return thunkAPI.rejectWithValue({
//         message: 'Error registering Access Codes',
//         error: e,
//       })
//     }
//   },
// )

export const addAccessCode = createAsyncThunk<
  AccessCodeType[] | undefined,
  AccessCodeArgs
>(
  'accessCode_slice/addAccessCode',
  async (
    {
      navigate, role_type, roles, codeType, contract_ref,
      business_client, email, expire_at, number_of_codes_to_generate,
    },
    thunkAPI,
  ) => {
    try {
      const user = getAuth().currentUser
      if (!user) return thunkAPI.rejectWithValue({ message: 'Not authenticated' })
      const token = await user.getIdToken()

      const res = await fetch(
        `${ACCESSCODE_V2_URL}addAccessCode_v2`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            role_type, roles, codeType, contract_ref,
            business_client, email, expire_at, number_of_codes_to_generate,
          }),
        },
      )

      const { data, message } = await res.json()
      if (!res.ok) throw new Error(message || 'Failed to create access codes')

      toast.success('Access codes created successfully!')

      if (navigate) navigate(`../accessCode/${data.firstId}`)

      return withDateOnlyExpiry(data.createdCodes)
    } catch (e) {
      return thunkAPI.rejectWithValue({
        message: 'Error registering Access Codes',
        error: e,
      })
    }
  },
)
interface AddClientArgs {
  pending_user_name: string
  pending_email: string
  clientId: string
  business_name?: string
}
interface addClientAndAccessCodeArgs {
  client: AddClientArgs
  accessCode: AccessCodeArgs
}

// export const addClientAndAccessCode = createAsyncThunk<
//   { createdCodes: AccessCodeType[]; newClient: PendingClientType } | undefined,
//   addClientAndAccessCodeArgs
// >(
//   'accessCode_slice/addClientAndAccessCode',
//   async (
//     {
//       client: {
//         pending_user_name,
//         pending_email,
//         clientId,
//         business_name = 'elisyan',
//       },
//       accessCode: {
//         role_type,
//         roles,
//         codeType,
//         contract_ref,
//         business_client,
//         email,
//         expire_at,
//         number_of_codes_to_generate,
//       },
//     },
//     thunkAPI,
//   ) => {
//     try {
//       const accessCodeCollection = collection(firestore, 'access_codes')
//       const contractRef = doc(firestore, `contracts/${contract_ref}`)
//       const contractSnap = await getDoc(contractRef)
//       let contract_expire_at: string = ''
//       if (contractSnap.exists()) {
//         const contractData = contractSnap.data()
//         contract_expire_at = contractData.expire_at || ''
//       } else {
//         //console.log("No such document!");
//       }
//       const business_clientRef = doc(firestore, `businesses/${business_client}`)
//       const businessdocSnap = await getDoc(business_clientRef)

//       if (businessdocSnap.exists()) {
//         const data = businessdocSnap.data()
//         business_name = data.name
//         // console.log("Business Name:", business_name);
//       }
//       const newAccessCodes = [] // Array to store the AccessCodeType objects
//       const newAccessCodesids: string[] = []
//       if (codeType === 'licence-code') {
//         for (let i = 0; i < number_of_codes_to_generate; i++) {
//           const newAccessCodeRef = doc(accessCodeCollection) // Generate a new document reference
//           const newCode = {
//             role_type: role_type,
//             roles: roles?.map((item) => item.value),
//             codeType,
//             contract_ref: contractRef, // Assuming contract_ref is a string path
//             business_client: business_clientRef,
//             email: email ?? [], // Default to an empty array if undefined
//             expire_at: expire_at ?? contract_expire_at, // Default to an empty string if undefined
//             created_at: (serverTimestamp() as unknown) as Timestamp,
//             updated_at: (serverTimestamp() as unknown) as Timestamp,
//             validated: false,
//             shared: false,
//           }

//           newAccessCodes.push(newCode) // Add the new code to the array
//           newAccessCodesids.push(newAccessCodeRef.id)
//         }
//       }

//       // Initialize the batch
//       const batch = writeBatch(firestore)

//       // Add each access code to the batch
//       newAccessCodes.forEach((accessCode, index) => {
//         const newAccessCodeRef = doc(
//           accessCodeCollection,
//           newAccessCodesids[index],
//         ) // Use the pre-generated ID
//         batch.set(newAccessCodeRef, accessCode) // Add the document to the batch
//       })

//       // Commit the batch write
//       try {
//         await batch.commit()
//         const createdCodes: AccessCodeType[] = newAccessCodes.map(
//           (code, index) => {
//             return {
//               ...code,
//               business_client: code.business_client.path.split('/')[1],
//               contract_ref: code.contract_ref.path.split('/')[1],
//               id: newAccessCodesids[index],
//               created_at: new Date().toISOString().slice(0, 10),
//               updated_at: new Date().toISOString().slice(0, 10),
//             }
//           },
//         )
//         // Update the contract to increase licence_count
//         await updateDoc(contractRef, {
//           licence_count: increment(number_of_codes_to_generate), // Increase licence_count by the number of codes generated
//         })

//         // Add the client to the clients collection
//         const usersCollection = collection(firestore, 'users')
//         const newClientRef = doc(usersCollection)
//         const newClient = {
//           pending_user_name: pending_user_name,
//           pending_email: pending_email,
//           clientId: clientId,
//           role_type: role_type,
//           roles: roles?.map((item) => item.value) || [], // Ensure roles is an array
//           business_name: business_name, // Assuming business_name is a string
//           created_at: (serverTimestamp() as unknown) as Timestamp,
//           updated_at: (serverTimestamp() as unknown) as Timestamp,
//           pending: true, //set this as pending
//           verificationStatus: 'pending', //set this as pending
//           access_code_data: createdCodes.map((code) => {
//             return { id: code.id, expire_at: code.expire_at }
//           }), // Link the access codes to the client
//           id: newClientRef.id, // Include the Firestore-generated ID
//         }
//         // Initialize the batch
//         try {
//           const batchClient = writeBatch(firestore)
//           batchClient.set(newClientRef, newClient) // Add the new client to the batch
//           await batchClient.commit() // Commit the batch write for both access codes and client
//           // console.log("Access codes and client created successfully!");

//           toast.success('Client Created  successfully!')
//           // if (navigate) {
//           //   navigate(`../clients`);
//           // }

//           return {
//             createdCodes,
//             newClient: newClient as PendingClientType, // Ensure the newClient is typed correctly
//           }
//         } catch (e) {
//           console.error('Error creating new client reference:', e)
//           return thunkAPI.rejectWithValue({
//             message: 'Error creating new client reference',
//             error: e,
//           })
//         }
//       } catch (error) {
//         console.error('Batch write failed:', error)
//         return thunkAPI.rejectWithValue({
//           message: 'Batch write failed',
//           error,
//         })
//       }
//     } catch (e) {
//       // console.log("Error registering Access Codes:", e);
//       return thunkAPI.rejectWithValue({
//         message: 'Error registering Access Codes',
//         error: e,
//       })
//     }
//   },
// )

// export const addReferralCode = createAsyncThunk<
//   AccessCodeType[] | undefined,
//   {
//     business_client: string
//     for_business_client: string
//     prefix?: string
//     expire_at: string
//     useLimit?: number
//     free_duration?: number | undefined
//     number_of_codes_to_generate: number
//     navigate?: (path: string) => void
//   }
// >(
//   'accessCode_slice/addReferralCode',
//   async (
//     {
//       business_client,
//       expire_at,
//       for_business_client = 'elisyan',
//       prefix,
//       useLimit = 1,
//       number_of_codes_to_generate = 1,
//       free_duration = undefined,
//       navigate,
//     },
//     thunkAPI,
//   ) => {
//     try {
//       console.log('fron create referral action', free_duration)
//       const accessCodeCollection = collection(firestore, 'access_codes')
//       const business_clientRef = doc(firestore, `businesses/${business_client}`)
//       const newReferralCodes = []
//       const newReferralCodeIds: string[] = []

//       for (let i = 0; i < number_of_codes_to_generate; i++) {
//         const newReferralCodeRef = doc(accessCodeCollection) // Generate a new document reference

//         // Construct the new referral code
//         const newCode: {
//           id: string
//           role_type: string
//           codeType: string
//           business_client: typeof business_clientRef
//           expire_at: string
//           for_business_client: string
//           prefix?: string
//           useLimit: number
//           useCount: number
//           created_at: Timestamp
//           updated_at: Timestamp
//           validated: boolean
//           shared: boolean
//           free_duration?: number
//         } = {
//           id: newReferralCodeRef.id,
//           role_type: 'client', // Set role_type if needed, or remove if not applicable
//           codeType: 'referral-code',
//           business_client: business_clientRef,
//           expire_at,
//           for_business_client,
//           prefix,
//           useLimit: Number(useLimit),
//           useCount: 0,
//           created_at: (serverTimestamp() as unknown) as Timestamp,
//           updated_at: (serverTimestamp() as unknown) as Timestamp,
//           validated: false,
//           shared: false,
//         }
//         if (free_duration) {
//           newCode.free_duration = free_duration // Add free_duration if provided
//         }

//         newReferralCodes.push(newCode)
//         newReferralCodeIds.push(newReferralCodeRef.id)
//       }

//       // Initialize the batch
//       const batch = writeBatch(firestore)

//       // Add each referral code to the batch
//       newReferralCodes.forEach((referralCode, index) => {
//         const newReferralCodeRef = doc(
//           accessCodeCollection,
//           newReferralCodeIds[index],
//         )
//         batch.set(newReferralCodeRef, referralCode)
//       })

//       // Commit the batch write
//       try {
//         await batch.commit()

//         const createdCodes: AccessCodeType[] = newReferralCodes.map(
//           (code, index) => ({
//             ...code,
//             id: newReferralCodeIds[index],
//             business_client: code.business_client.path.split('/')[1],
//             created_at: new Date().toISOString().slice(0, 10),
//             updated_at: new Date().toISOString().slice(0, 10),
//           }),
//         )

//         toast.success('Referral codes created successfully!')

//         if (navigate) {
//           navigate(`../accessCode/${newReferralCodeIds[0]}`)
//         }

//         return createdCodes
//       } catch (error) {
//         console.error('Batch write failed:', error)
//         return thunkAPI.rejectWithValue({
//           message: 'Batch write failed',
//           error,
//         })
//       }
//     } catch (e) {
//       // console.log("Error creating referral codes:", e);
//       return thunkAPI.rejectWithValue({
//         message: 'Error creating referral codes',
//         error: e,
//       })
//     }
//   },
// )


export const addClientAndAccessCode = createAsyncThunk<
  { createdCodes: AccessCodeType[]; newClient: PendingClientType } | undefined,
  addClientAndAccessCodeArgs
>(
  'accessCode_slice/addClientAndAccessCode',
  async ({ client, accessCode }, thunkAPI) => {
    try {
      const user = getAuth().currentUser
      if (!user) return thunkAPI.rejectWithValue({ message: 'Not authenticated' })
      const token = await user.getIdToken()

      const res = await fetch(
        `${ACCESSCODE_V2_URL}addClientAndAccessCode_v2`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ client, accessCode }),
        },
      )

      const { data, message } = await res.json()
      if (!res.ok) throw new Error(message || 'Failed to create client and access codes')

      toast.success('Client created successfully!')

      return {
        createdCodes: withDateOnlyExpiry(data.createdCodes),
        newClient: data.newClient as PendingClientType,
      }
    } catch (e) {
      return thunkAPI.rejectWithValue({
        message: 'Error registering Access Codes',
        error: e,
      })
    }
  },
)

export const addReferralCode = createAsyncThunk<
  AccessCodeType[] | undefined,
  {
    business_client: string
    for_business_client: string
    prefix?: string
    expire_at: string
    useLimit?: number
    free_duration?: number | undefined
    number_of_codes_to_generate: number
    navigate?: (path: string) => void
  }
>(
  'accessCode_slice/addReferralCode',
  async (
    {
      business_client, for_business_client, prefix, expire_at,
      useLimit, free_duration, number_of_codes_to_generate, navigate,
    },
    thunkAPI,
  ) => {
    try {
      const user = getAuth().currentUser
      if (!user) return thunkAPI.rejectWithValue({ message: 'Not authenticated' })
      const token = await user.getIdToken()

      const res = await fetch(
        `${ACCESSCODE_V2_URL}addReferralCode_v2`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            business_client, for_business_client, prefix, expire_at,
            useLimit, free_duration, number_of_codes_to_generate,
          }),
        },
      )

      const { data, message } = await res.json()
      if (!res.ok) throw new Error(message || 'Failed to create referral codes')

      toast.success('Referral codes created successfully!')

      if (navigate) navigate(`../accessCode/${data.firstId}`)

      return withDateOnlyExpiry(data.createdCodes)
    } catch (e) {
      return thunkAPI.rejectWithValue({
        message: 'Error creating referral codes',
        error: e,
      })
    }
  },
)

export const addWhitelabelReferralCode = createAsyncThunk<
  AccessCodeType[] | undefined,
  {
    business_client: string
    prefix?: string
    expire_at: string
    useLimit?: number
    navigate?: (path: string) => void
    contract_ref: string,
    free_access_end_date?: number
  }
>(
  'accessCode_slice/addReferralCode',
  async (
    {
      business_client, prefix, expire_at,
      useLimit, navigate, contract_ref, free_access_end_date
    },
    thunkAPI,
  ) => {
    try {
      const user = getAuth().currentUser
      if (!user) return thunkAPI.rejectWithValue({ message: 'Not authenticated' })
      const token = await user.getIdToken()

      const res = await fetch(
        `${ACCESSCODE_V2_URL}addWhitelabelReferralCode_v2`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            business_client, prefix, expire_at,
            useLimit, contract_ref: contract_ref || 'whitelabel',free_access_end_date
          }),
        },
      )

      const { data, message } = await res.json()
      if (!res.ok) throw new Error(message || 'Failed to create referral codes')

      toast.success('Referral codes created successfully!')

      if (navigate) navigate(`../accessCode/${data.firstId}`)

      return withDateOnlyExpiry(data.createdCodes)
    } catch (e) {
      return thunkAPI.rejectWithValue({
        message: 'Error creating referral codes',
        error: e,
      })
    }
  },
)


// export const getAccessCodes = createAsyncThunk<
//   AccessCodeType[] | undefined,
//   { business_client?: string } // Make business_client optional
// >("accessCode_slice/getAccessCodes", async ({ business_client }, thunkAPI) => {
//   try {
//     const accessCodesRef = collection(firestore, "access_codes");
//     let querySnapshot;

//     // Check if business_client is provided and valid
//     if (business_client && business_client.length > 2) {
//       const businessDocRef = doc(firestore, `businesses/${business_client}`);
//       const accessCodesQuery = query(
//         accessCodesRef,
//         where("business_client", "==", businessDocRef)
//       );
//       querySnapshot = await getDocs(accessCodesQuery);
//     } else {
//       // If no business_client provided, return all access codes
//       querySnapshot = await getDocs(accessCodesRef);
//     }

//     let data;
//     const accessCodes: AccessCodeType[] = querySnapshot.docs.map((doc) => {
//       data = doc.data();
//       return {
//         id: doc.id,
//         // Add your specific fields according to the access code structure
//         role_type: data.role_type,
//         roles: data.roles, // Default to an empty array if roles is undefined
//         codeType: data.codeType,
//         contract_ref: data.contract_ref
//           ? data.contract_ref.path.split("/")[1]
//           : undefined, // contract_ref is a string path or undefined
//         useCount: data.useCount ? data.useCount : 0,
//         useLimit: data.useLimit ? data.useLimit : 0,
//         business_client: data.business_client.path.split("/")[1], // Assuming business_client is also a string path
//         for_business_client: data.for_business_client
//           ? data.for_business_client
//           : undefined,
//         email: data.email || [], // Default to an empty array if undefined
//         expire_at: data.expire_at || "", // Default to an empty string if undefined
//         created_at: data.created_at, //serverTimestamp() as unknown as Timestamp,
//         updated_at: data.updated_at, //serverTimestamp() as unknown as Timestamp,
//         validated: data.validated,
//         shared: data.shared,
//         prefix: data.prefix,
//         // Add other fields as necessary
//       };
//     });

//     return accessCodes;
//   } catch (e) {
//     console.log("-------------- Error getAccessCodes: " + e);
//     return thunkAPI.rejectWithValue({
//       message: "Error retrieving access codes",
//       error: e,
//     } as ErrorResponse);
//   }
// });

export const getAccessCodes = createAsyncThunk<
  AccessCodeType[],
  { business_names: string[] }
>('accessCode_slice/getAccessCodes', async ({ business_names }, thunkAPI) => {
  try {
      // Get the current user's token directly from Firebase Auth
      const auth = getAuth();
      const user = auth.currentUser;
      
      if (!user) {
        return thunkAPI.rejectWithValue('User not authenticated');
      }
      
      // Get fresh token (Firebase automatically refreshes if needed)
      const token = await user.getIdToken();
    // console.log('from get access codes action before ', business_names)
    const res = await fetch(
      `${ACCESSCODE_V2_URL}getAccessCodesByBusinesses_v2`,
      {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ business_names }),
      },
    )
    const { data, message } = await res.json()
    // console.log('from get access codes action after',res.ok, data)
    if (!res.ok) throw new Error(message || 'Fetch failed')

    const accessCodes: AccessCodeType[] = (Array.isArray(data) ? data : []).map(mapRawAccessCode)

    // console.log('from get access codes action ', accessCodes)

    return accessCodes
  } catch (err) {
    return thunkAPI.rejectWithValue({
      message:
        err instanceof Error ? err.message : 'Error loading access codes',
    })
  }
})

/**
 * Sends a single client invitation email for an access code the admin
 * picked from the ones the selected business already owns (no code is
 * generated here any more — see the Send Invitation form).
 *
 * POSTs to the invitation-email Lambda (`sendInviteDispatch`) with emailCode
 * "B06" (invitation template) and `clientEmail` = the same address ("send on
 * behalf" isn't implemented yet).
 */
export async function sendClientInvitation(params: {
  email: string
  name: string
  businessName: string
  preferredLanguage: string
  inviteCode: string
}): Promise<{ inviteCode: string }> {
  if (!params.inviteCode) {
    throw new Error('Select an access code to send')
  }

  await sendInviteDispatch({
    email: params.email,
    name: params.name,
    emailCode: 'B06',
    companyCode: params.businessName,
    preferredLanguage: params.preferredLanguage,
    extras: {
      inviteCode: params.inviteCode,
      clientEmail: params.email,
    },
  })

  return { inviteCode: params.inviteCode }
}
